<template>
  <tr class="estableshiment-table-item">
    <td class="col-sm">
      <app-toggle v-model="isActive"></app-toggle>
    </td>

    <td v-if="isAdmin">
      {{item.id}}
    </td>
    <td>
      {{item.nameMaster}}
    </td>

    <td>
      {{item.localAccount}}
    </td>

    <td>
      {{item.accessPointCount}}
    </td>

    <td>
      {{item.activeCampaignsCount}}
    </td>

    <td>
      {{$date.format(item.registrationDate)}}
    </td>

    <td class="estableshiment-table-item-last_login">
      {{ lastLogin }}
    </td>

    <td class="edit">
      <i
        class="mdi mdi-comment-text-outline pointer"
        v-tooltip="$t('message.admEstablishments.message.creditManagement')"
        @click="() => (showCreditsModal = !showCreditsModal)"
        v-if="!isParceiro"
      ></i>

      <i v-if="canCreateEstablishment"
        class="mdi mdi-settings pointer"
        v-tooltip="$t('message.generics.message.settings')"
        @click="settings"
      ></i>

      <i v-if="isAdmin"
        class="mdi mdi-monitor-dashboard pointer"
        v-tooltip="'Integrações permitidas'"
        @click="showIntegrationsModal = true"
      ></i>

      <i v-if="canCreateEstablishment"
        class="mdi mdi-square-edit-outline pointer"
        v-tooltip="$t('message.generics.message.edit')"
        @click="edit"
      ></i>

      <i
        class="mdi mdi-eye pointer"
        v-tooltip="$t('message.admGenerics.message.access')"
        @click="access"
      ></i>

      <i
        v-if="isAdmin"
        class="pointer"
        :class="[
          item.idPartner != null
            ? 'mdi mdi-account-plus'
            : 'mdi mdi-account-remove',
        ]"
        v-tooltip="
          item.namePartner != null
            ? item.namePartner
            : $t('message.admEstablishments.message.noPartner')
        "
        @click="() => (showPartnerManageModal = !showPartnerManageModal)"
      ></i>
    </td>

    <app-confirmation-modal
      v-if="!!pendingChangeActive"
      :value="!!pendingChangeActive"
      confirm-label="Confirmar"
      @confirm="confirmStatusToggle"
      @cancel="cancelChangeActive"
    >
      <span slot="heading">
        {{$t('message.admEstablishments.message.deactivateEstablishment')}}
      </span>
      <span>
        {{$t('message.admEstablishments.message.confirmEstabDeactivation')}}
      </span>
    </app-confirmation-modal>

    <admin-establishments-marketing-credits-modal
      v-if="showCreditsModal"
      v-model="showCreditsModal"
      :item="item"
      @change-modal-visibility="changeModalVisibility"
    />

    <partner-manage-modal
      v-if="showPartnerManageModal"
      v-model="showPartnerManageModal"
      :item="item"
      @update="closeModalPartner"
    />

    <establishments-integration-manager-modal v-if="showIntegrationsModal" 
                                              v-model="showIntegrationsModal" 
                                              :establishment-id="item.id" 
                                              @on-update="showIntegrationsModal = false"/>
    
  </tr>
</template>

<script>
import AdminEstablishmentsMarketingCreditsModal from "@components/admin/establishments/marketing/credits/modal/AdminEstablishmentsMarketingCreditsModal";
import PartnerManageModal from "@/components/modules/partner/manage/modal/PartnerManageModal";
import EventBus from "@packages/event-bus";
import userTableItem from "@views/admin/mixins/user-table-item";
import EstablishmentsIntegrationManagerModal from "./EstablishmentsIntegrationManagerModal.vue";

export default {
  components: {
    PartnerManageModal,
    AdminEstablishmentsMarketingCreditsModal,
    EstablishmentsIntegrationManagerModal
  },
  data() {
    return {
      entity: "establishments",
      showCreditsModal: false,
      showPartnerManageModal: false,
      showWhatsAppConfigModal: false,
      showIntegrationsModal: false
    };
  },

  computed: {
    isParceiro() {
      return (
        this.$store.state.users.user != null &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },
    lastLogin() {
      return this.item.lastLogin
        ? this.$date.format(this.item.lastLogin)
        : "---";
    },
    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
     canCreateEstablishment() {
      return this.isAdmin || this.permissions.includes("CREATE_ESTABLISHMENT");
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    item() {
      return this.dataItem;
    },
    isActive: {
      get() {
        return this.item.isActive;
      },
      set(value) {
        this.item.isActive = value;
        if (value) {
          this.confirmStatusToggle();
        } else {
          this.changeActive();
        }
      },
    },
  },

  mounted() {
    EventBus.$on("USER_CHECKS_CHANGED", this.updateUserAllowSms);
  },

  beforeDestroy() {
    EventBus.$off("USER_CHECKS_CHANGED", this.updateUserAllowSms);
  },

  methods: {    
    changeModalVisibility(val) {
      const modal = document.querySelector('.admin-marketing-credits-modal')
      if(modal) {
        modal.style.visibility = val
      }
    },
    updateUserAllowSms(data) {
      if (this.item.id === data.id) {
        this.item.permitirUtilizarSMS = data.checks.allowSms;
      }
    },
    closeModalPartner(bool) {
      this.showPartnerManageModal = bool;
    },
    async confirmStatusToggle() {
      await this.$api[this.entity].toggleStatus(this.item.id);

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t("message.successMessages.message.operationSuccessful"),
        timeout: 3500,
      });

      this.pendingChangeActive = null;
    },
  },

  mixins: [userTableItem],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.estableshiment-table-item {
  .estableshiment-table-item-last_login {
    text-align: center;
  }
}

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }

    &.mdi-account-plus {
      color: green;
    }
  }
}
</style>
